import { ReactNode } from 'react';
import { IStyled } from '../styles/types';
import useResizeLayout from './utils/useResizeLayout';
import * as LayoutUI from './LayoutUI';

interface IProps extends IStyled {
  children: ReactNode;
}

const LayoutContainer = ({ children, className }: IProps) => {
  const ref = useResizeLayout();

  return (
    <LayoutUI.Container ref={ref} className={className}>
      {children}
    </LayoutUI.Container>
  );
};

export default LayoutContainer;
